<template>
  <div class="breadcrumbs">

    <span v-for="(child, index) in children" :key="child.text">
      <span v-if="index > 0">&nbsp;/&nbsp;</span>
      <router-link v-if="child.link" :to="`/${child.link}`" class="child main-green">
        {{ child.text }}
      </router-link>
      <span v-else>{{ child.text }}</span>
    </span>
        
  </div>
</template>

<script>

export default {
  name: 'Breadcrumbs',
  props: [
    'children'
  ],
  data:function(){
    return {
      subchild: ''
    }
  },
  methods: {

  },  
}
</script>

<style lang="scss" scoped>
  .breadcrumbs{
    display: flex;
    padding: 10px 15px;
    margin-bottom: 22px;
    background-color: #fff;
    -webkit-box-shadow: 0px 4px 11px -4px rgba(0,0,0,0.8);
    -moz-box-shadow: 0px 4px 11px -4px rgba(0,0,0,0.8);
    box-shadow: 0px 4px 11px -4px rgba(0,0,0,0.8);  
    font-size: 1.4em;
    .base{
      font-weight: 500;
    }
    .child{
      font-weight: 400;
    }
  }
</style>